import { Info } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IProjectDetails } from 'projects/types';
import { Variant } from 'theme/enums';

import { ProjectDetailsDrawer } from './ProjectDetailsDrawer';

interface IProps {
  project: IProjectDetails;
}

export const ProjectDetailsDrawerButton = ({ project }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        text={t('buttonLabelProjectDetails')}
        startDecorator={<Info />}
        variant={Variant.OUTLINED}
        onClick={() => setIsOpen(true)}
      />

      <ProjectDetailsDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} project={project} />
    </>
  );
};
